import type { ViewIssueData as IssueServiceViewIssueData } from '@atlassian/jira-issue-fetch-services/src/types.tsx';
import type { TotalAttachmentsCountResponse } from '@atlassian/jira-issue-gira-transformer-types/src/common/types/attachments.tsx';
import type { ViewIssueData } from '@atlassian/jira-issue-gira-transformer-types/src/common/types/server-data.tsx';

export const transformData = (
	issue: ViewIssueData | IssueServiceViewIssueData,
): TotalAttachmentsCountResponse => ({
	totalAttachmentsCount: issue.totalAttachmentsCount || 0,
});
